import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

// eslint-disable-next-line import/no-unresolved
import { StartQuoteComponent, PaymentPage, AffiliationPage } from 'ml-capability-quoteandbind-common-react';

import SummaryPage from './pages/Summary/SummaryPage';
import ConfirmationPage from './pages/Confirmation/ConfirmationPage';
import ESignaturePage from './pages/ESignature/ESignaturePage';
import AdjustmentsPage from './pages/Adjustments/AdjustmentsPage';
import AccountSyncPage from './pages/AccountSync/AccountSyncPage';

import QuoteWizardPageTemplate from './components/QuoteWizardPageTemplate';
import LineOfBusiness from './components/LineOfBusiness/LineOfBusiness';
import RetrieveQuote from './components/RetrieveQuote/RetrieveQuote';
import CustomQuoteComponent from './components/CustomQuoteComponent/CustomQuoteComponent';
import QuoteSummaryBarComponent from './components/QuoteSummaryBarComponent/QuoteSummaryBarComponent';
import StateFeesComponent from './components/StateFeesComponent/StateFeesComponent';
import VehicleInfoComponent from './components/VehicleInfoComponent/VehicleInfoComponent';
import PolicySummaryConfirmationBoxComponent from './components/PolicySummaryConfirmationBoxComponent/PolicySummaryConfirmationBoxComponent';
import PolicySummaryInsuredInfoComponent from './components/PolicySummaryInsuredInfoComponent/PolicySummaryInsuredInfoComponent';
import PolicySummaryDriversComponent from './components/PolicySummaryDriversComponent/PolicySummaryDriversComponent';
import IncludedFeaturesComponent from './components/IncludedFeaturesComponent/IncludedFeaturesComponent';
import AdditionalInterestListComponent from './components/AdditionalInterestListComponent/AdditionalInterestListComponent';
import EsignatureComponent from './components/EsignatureComponent/EsignatureComponent';
import PolicySummaryAdditionalInterestsComponent from './components/PolicySummaryAdditionalInterestsComponent/PolicySummaryAdditionalInterestsComponent';
import VehicleVinLookupComponent from './components/VehicleVinLookupComponent/VehicleVinLookupComponent';
import CustomHeaderComponent from './components/CustomHeaderComponent/CustomHeaderComponent';
import CustomFooterComponent from './components/CustomFooterComponent/CustomFooterComponent';
import MLAgentPolicySummaryHeaderComponent from './components/MLAgentPolicySummaryHeader/MLAgentPolicySummaryHeaderComponent';

export { default as commonMessages } from './quoteandbind.messages';
export { default as commonQuoteStyles } from './quoteandbind-common-styles.module.scss';
export { default as PaymentDetailsPage } from './pages/PaymentDetails/PaymentDetailsPage';
export { default as YourInfoPage } from './pages/YourInfo/YourInfoPage';
export { default as QuotePage } from './pages/Quote/QuotePage';
export { default as QuoteInfo } from './components/CommonQuoteInfo/CommonQuoteInfo';
export { default as QuickQuoteWizardPageTemplate } from './components/QuickQuoteWizardPageTemplate';
export { QuoteInfoComponentContext, withQuoteInfoComponent } from './components/QuoteInfoComponentContext';
export { QuoteWizardPageTemplate };
export { CustomHeaderComponent, CustomFooterComponent }
export {
    AffiliationPage,
    AdjustmentsPage,
    SummaryPage,
    ConfirmationPage,
    ESignaturePage,
    AccountSyncPage,
    PaymentPage,
    StateFeesComponent
}

export { default as MLAgentPolicySummaryHeaderComponent } from './components/MLAgentPolicySummaryHeader/MLAgentPolicySummaryHeaderComponent';


setComponentMapOverrides(
    {
        QuoteWizardPageTemplate: { component: 'QuoteWizardPageTemplate' },
        LineOfBusiness: { component: 'LineOfBusiness' },
        RetrieveQuote: { component: 'RetrieveQuote' },
        StartQuoteComponent: { component: 'StartQuoteComponent' },
        CustomQuoteComponent: { component: 'CustomQuoteComponent' },
        QuoteSummaryBarComponent: { component: 'QuoteSummaryBarComponent' },
        StateFeesComponent: { component: 'StateFeesComponent' },
        VehicleInfoComponent: { component: 'VehicleInfoComponent' },
        PolicySummaryConfirmationBoxComponent: { component: 'PolicySummaryConfirmationBoxComponent' },
        PolicySummaryInsuredInfoComponent: { component: 'PolicySummaryInsuredInfoComponent' },
        PolicySummaryDriversComponent: { component: 'PolicySummaryDriversComponent' },
        IncludedFeaturesComponent: { component: 'IncludedFeaturesComponent' },
        AdditionalInterestListComponent: { component: 'AdditionalInterestListComponent' },
        EsignatureComponent: { component: 'EsignatureComponent' },
        PolicySummaryAdditionalInterestsComponent: { component: 'PolicySummaryAdditionalInterestsComponent' },
        VehicleVinLookupComponent: { component: 'VehicleVinLookupComponent' },
        CustomHeaderComponent: { component: 'CustomHeaderComponent' },
        CustomFooterComponent: { component: 'CustomFooterComponent' },
        MLAgentPolicySummaryHeaderComponent: { component: 'MLAgentPolicySummaryHeaderComponent' },

        AffiliationPage: { component: 'AffiliationPage' },
        AdjustmentsPage: { component: 'AdjustmentsPage' },
        SummaryPage: { component: 'SummaryPage' },
        ConfirmationPage: { component: 'ConfirmationPage' },
        ESignaturePage: { component: 'ESignaturePage' },
        AccountSyncPage: { component: 'AccountSyncPage' },
        PaymentPage: { component: 'PaymentPage' }
    },
    {
        QuoteWizardPageTemplate,
        LineOfBusiness,
        RetrieveQuote,
        StartQuoteComponent,
        CustomQuoteComponent,
        QuoteSummaryBarComponent,
        StateFeesComponent,
        VehicleInfoComponent,
        PolicySummaryConfirmationBoxComponent,
        PolicySummaryInsuredInfoComponent,
        PolicySummaryDriversComponent,
        IncludedFeaturesComponent,
        AdditionalInterestListComponent,
        EsignatureComponent,
        PolicySummaryAdditionalInterestsComponent,
        VehicleVinLookupComponent,
        CustomHeaderComponent,
        CustomFooterComponent,
        MLAgentPolicySummaryHeaderComponent,

        AffiliationPage,
        AdjustmentsPage,
        SummaryPage,
        ConfirmationPage,
        ESignaturePage,
        AccountSyncPage,
        PaymentPage

    }
);
